import { GroupStep, State } from "~/lib/pipeline";
import { useSteps } from "~/components/build/Show/lib/useSteps";
import { useMemo } from "react";

// Given group of steps, display a count of the number of finished steps in that group.
export const GroupStepCount = ({ step }: { step: GroupStep }) => {
  const { steps, groupStepsMap } = useSteps();

  const groupChildren = useMemo(() => {
    return (groupStepsMap.get(step.uuid) || []).filter(
      (step) => step.type !== "wait" && step.state !== State.Ignored,
    );
  }, [steps, step]);

  const finishedCount = useMemo(() => {
    return groupChildren.filter((step) => step.state === State.Finished).length;
  }, [groupChildren]);

  if (!groupChildren.length) {
    return null;
  }

  return (
    <span className="text-charcoal-700 rounded-sm border border-slate-500 bg-white px-1 tabular-nums">
      {finishedCount}/{groupChildren.length}
    </span>
  );
};
